import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setCurrentTableStateAC } from "store/actions/table";

export const useFilteredRows = () => {
  const dispatch = useDispatch();

  const filteredRows = useSelector(
    (state) => state.table.currentTableState.filteredRows
  );

  const handleRowsChange = useCallback(
    (filteredRows) =>
      dispatch(
        setCurrentTableStateAC({
          filteredRows: filteredRows.map(({ original }) => original),
        })
      ),
    [dispatch]
  );

  return {
    handleRowsChange,
    filteredRows,
  };
};

export default useFilteredRows;
